import { useQuery } from "@tanstack/react-query";
import { GatewayService, type SessionInfo } from "../api/gateway.service";

/** State and actions returned by {@link useSessions}. */
export interface UseSessionsReturn {
    sessions: SessionInfo[];
    loading: boolean;
    error: Error | null;
    /** Re-run the sessions query. */
    refetch: () => void;
}

/**
 * The current user's own active device sessions.
 *
 * @example
 * ```tsx
 * const { sessions, loading, refetch } = useSessions();
 * ```
 */
export const useSessions = (): UseSessionsReturn => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["gateway", "sessions"],
        queryFn: ({ signal }) => GatewayService.getSessions({ signal }),
    });
    return {
        sessions: data ?? [],
        loading: isLoading,
        error,
        refetch: () => { void refetch(); },
    };
};
